import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccommodationsAvailabilitySetComponent } from '../accommodations-availability-set/accommodations-availability-set.component';

import { AccommodationsService } from '../accommodations.service';
import { AccommodationsDataService } from '../accommodations-data.service';
import { AccommodationsProductWithoutRoomsComponent } from '../accommodations-product-without-rooms/accommodations-product-without-rooms.component';

@Component({
	selector: 'app-accommodations-products',
	templateUrl: './accommodations-products.component.html',
	styleUrls: ['./accommodations-products.component.scss'],
})
export class AccommodationsProductsComponent {
	@Input() products = [];

	constructor(
		protected service: AccommodationsService,
		private readonly dataService: AccommodationsDataService,
		private readonly dialog: MatDialog,
	) {}

	protected availabilitySet(product): void {
		this.dialog
			.open(AccommodationsAvailabilitySetComponent, {
				data: { product },
				disableClose: true,
			})
			.afterClosed()
			.subscribe((result) => {
				if (!result) {
					return;
				}
				this.dataService.loadAvailabilities();
			});
	}

	protected capaciteisWihtOutRooms(product): void {
		this.dialog.open(AccommodationsProductWithoutRoomsComponent, {
			data: product,
			disableClose: false,
			width: '1200px',
		});
	}
}
